<template>
  <keep-alive>
    <component
      :is="componentType"
      :id="`n${id}`"
      :type="type"
      :links="links"
      :attributes="attributes"
      :relationships="relationships"
      :class="classes"
      :disabled="disabled"
      v-bind="$attrs"
    ></component>
  </keep-alive>
</template>

<script>
import { getElementType } from '@/js/helper/content-element-helper.js'

import ElementPropsMixin from '@/js/mixins/element-props-mixin.js'
import components, { mapItem } from './utils/navigation-components.js'

export default {
  name: 'NavigationElement',
  components,
  mixins: [ElementPropsMixin],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      componentType: mapItem(getElementType(this.type)),
    }
  },
  computed: {
    classes() {
      return [{ [this.$style.emphasized]: !!this.attributes.emphasized }]
    },
  },
}
</script>

<style lang="scss" module>
.emphasized {
  font-weight: var(--font-weight-medium) !important;
  text-transform: uppercase !important;
}

:global(.mobile-MobileMenuHeader__mobile-nav__header) {
  :global(.components-FavoritesDialog__button) {
    :global(.Navigation-NavigationIconItem__item-icon) {
      path {
        stroke-width: 1;

        stroke: var(--primary);
      }
    }
  }
}
</style>
